import { FC } from 'react'
import classes from './Dialog.module.css'
import { Button, ButtonProps } from '../../'

type DialogProps = {
  title: string
  message?: string
  actions: ButtonProps[]
}

export const Dialog: FC<DialogProps> = ({ actions, message, title, children }) => {
  return (
    <div className={classes.root}>
      <div className={classes.dialog}>
        <div className={classes.header}>{title}</div>
        <div className={classes.body} hidden={!(message || children)}>{message || children}</div>
        <div className={classes.footer}>
          {actions.map((a, index) => <Button key={`${index}_${a.label}`} {...a}/>)}
        </div>
      </div>
    </div>
  )
}
